import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavManager } from '../services/nav-manager';
import { FilterProvider } from '../services/filter-provider';

@NgModule({
  providers: [NavManager, FilterProvider],
})
export class CoreModule {}
